import { ProcedimentoConTask } from 'client/api/backend/schemas';
import moment from 'moment';

export interface ITaskNote {
  outcome: string | null | undefined;
  outcomeDate: Date | null | undefined;
  note: string | null | undefined;
  taskName: string | null | undefined;
  userName: string | null | undefined;
  userFiscalNumber: string | null | undefined;
}

export function mapProcedureNotes(
  info: ProcedimentoConTask | undefined
): ITaskNote[] {
  if (!info?.task) return [];
  const result = info.task
    .map(task =>
      task
        .infoLavorazioneTask!.filter(data => !!data.noteCompletamento)
        .map(data => ({
          outcome: data.labelEsitoCompletamento,
          outcomeDate: moment(
            data.dataCompletamento,
            'DD/MM/YYYY HH:mm:ss'
          ).toDate(),
          note: data.noteCompletamento,
          taskName: task.name,
          userName: data.nomeUtenteLavorazione,
          userFiscalNumber: data.cfUtenteLavorazione
        }))
    )
    .flat();

  return result ?? [];
}
